// import React from "react";
// import {
//   Page,
//   Text,
//   View,
//   Document,
//   StyleSheet,
//   Image,
// } from "@react-pdf/renderer";

// import headerImg from "./assets/header.jpg";
// import footerImg from "./assets/footer.jpg";
// import { splitWord } from "../../../../../../utils/functions";

// const pdfData = {
//   refId: 243,
//   generated_Date: "12/09/2023",
//   authurized_person_name: "Amar",
//   client_name: "Akash",
//   visa_provider: "soudline",
//   second_party: "sla",
//   table: {
//     titiles: [
//       "Sl.No",
//       "Actual Profession",
//       "Visa Profession",
//       "Profession Level",
//       "Gender",
//       "Nationality",
//       "Quantity",
//       "Basic",
//       "Food",
//       "Fixed OT",
//       "HRA",
//       "Travel Allowance",
//       "Mobile Allowance",
//       "Monthly Service Charges (each in SAR)",
//     ],
//     tableRows: [
//       {
//         id: " ",
//         actual_profession: " ",
//         visa_profession: " ",
//         profession_level: " ",
//         gender: " ",
//         nationality: " ",
//         quantity: " ",
//         basic: " ",
//         food: " ",
//         fixed_of: " ",
//       },
//       {
//         id: " ",
//         actual_profession: " ",
//         visa_profession: " ",
//         profession_level: " ",
//         gender: " ",
//         nationality: " ",
//         quantity: " ",
//         basic: " ",
//         food: " ",
//         fixed_of: " ",
//       },
//       {
//         id: " ",
//         actual_profession: " ",
//         visa_profession: " ",
//         profession_level: " ",
//         gender: " ",
//         nationality: " ",
//         quantity: " ",
//         basic: " ",
//         food: " ",
//         fixed_of: " ",
//       },
//       {
//         id: " ",
//         actual_profession: " ",
//         visa_profession: " ",
//         profession_level: " ",
//         gender: " ",
//         nationality: " ",
//         quantity: " ",
//         basic: " ",
//         food: " ",
//         fixed_of: " ",
//       },
//     ],
//   },
// };

// const table2 = [
//   {
//     col_1: 1,
//     col_2: "Contract Period",
//     col_3:
//       "24 months, upon expiry contract shall be renewed automatically for the same period, if either party did not submit their consent to terminate on expiry",
//   },
//   {
//     col_1: 2,
//     col_2: "Accommodation",
//     col_3: "Provided by Second Party",
//   },
//   {
//     col_1: 3,
//     col_2: "Transportation",
//     col_3: "Provided by Second Party",
//   },
//   {
//     col_1: 4,
//     col_2: "Working hours",
//     col_3: "9 hrs. per day (Including 1 hour break) and 6 days a week.",
//   },
//   {
//     col_1: 5,
//     col_2: "OT / incentives",
//     col_3:
//       "Second Party can pay directly OR can advise First Party in the monthly timesheet, same shall be invoiced accordingly.",
//   },
//   {
//     col_1: 6,
//     col_2: "Hiring Type",
//     col_3: "Overseas",
//   },
//   {
//     col_1: 7,
//     col_2: "Recruitment Type",
//     col_3: "By Second Party",
//   },
//   {
//     col_1: 8,
//     col_2: "Recruitment & Visa stamping charges",
//     col_3: "Borne by Candidates or Second Party",
//   },
//   {
//     col_1: 9,
//     col_2: "Joining Air tickets",
//     col_3: "Borne by Second Party",
//   },
//   {
//     col_1: 10,
//     col_2: "Airport pick-up & drop",
//     col_3: "Shall be arranged by Second Party",
//   },
//   {
//     col_1: 11,
//     col_2: "Deployment",
//     col_3: "30 days based on current travel restrictions.",
//   },
//   {
//     col_1: 12,
//     col_2: "Deployment Sector",
//     col_3: "Kingdom of Saudi Arabia",
//   },
//   {
//     col_1: 13,
//     col_2: "Initial Invoice: Refundable Security Deposit Amount",
//     col_3:
//       "A refundable security deposit of 2 months of Monthly Service Charge via bank/cash/wire transfer for each employee provided by the FIRST PARTY to meet the salaries, monthly fees and related expenses.  Initial invoice payment should be made within 10 days after signatory procedures & submission of the contract.",
//   },
//   {
//     col_1: 14,
//     col_2: "Local Formalities",
//     col_3:
//       "First party will complete all local formalities of the candidates such as visa, iqama medical test, iqama, work-permit, Insurance, Exit re-entry visa, vacation salary, vacation air ticket, Final Exit.",
//   },
//   {
//     col_1: 15,
//     col_2: "Monthly invoice Payment Terms",
//     col_3:
//       "Second Party shall clear monthly invoice payment within 3-4 days of Invoice submission.",
//   },
//   {
//     col_1: 16,
//     col_2: "Offer Validity",
//     col_3: "7 Days only from date Quotation raised",
//   },
// ];

// export default function MonthlyQuotation({
//   generatedTitles,
//   quotationDetails,
//   TableRowLists,
//   terms,
//   notes,
// }) {
//   const company = quotationDetails?.quotation?.company || {};
//   const styles = StyleSheet.create({
//     page: {
//       backgroundColor: "white",
//       paddingTop: 15,
//       paddingBottom: 100,
//       paddingHorizontal: 25,
//       fontSize: 12,
//     },
//   });

//   function returnSrc(path = "") {
//     return {
//       uri: path,
//       method: "GET",
//       body: "",
//       headers: { "Cache-Control": "no-cache" },
//     };
//   }
//   return (
//     <Document>
//       <Page size="A4" style={styles.page}>
//         <View>
//           <Image
//             src={
//               company?.header && company?.header != ""
//                 ? returnSrc(company?.header)
//                 : headerImg
//             }
//             // fixed
//             // style={{ marginBottom: 30 }}
//           />
//         </View>

//         <View>
//           <Text
//             style={{
//               textAlign: "center",
//               textDecoration: "underline",
//               marginTop: 10,
//               fontSize: 12,
//               fontFamily: "Helvetica-Bold",
//             }}
//           >
//             QUOTATION
//           </Text>
//           <View
//             style={{
//               flexDirection: "row",
//               alignItems: "center",
//               justifyContent: "space-between",
//               marginTop: 10,
//               fontSize: 12,
//             }}
//           >
//             <Text>
//               Ref no:{" "}
//               <Text style={{ color: "red" }}>
//                 {quotationDetails?.quotation?.reference_number}
//               </Text>
//             </Text>
//             <Text>
//               Date: <Text style={{ color: "red" }}>{formattedDate}</Text>
//             </Text>
//           </View>
//           <View style={{ fontSize: 11, marginTop: 10 }}>
//             <Text style={{ marginBottom: 1 }}>To,</Text>
//             <Text style={{ marginBottom: 1, color: "red" }}>
//               {quotationDetails?.quotation?.client?.authorized_person_name}
//             </Text>
//             <Text style={{ marginBottom: 1, color: "red" }}>
//               {quotationDetails?.client}
//             </Text>
//             <Text style={{ fontFamily: "Helvetica-Bold" }}>Jeddah, K.S.A.</Text>
//           </View>
//           <Text style={{ marginTop: 15 }}>Dear Sir,</Text>
//           <Text style={{ marginTop: 15 }}>
//             Thank you for having trusted us and giving an opportunity to serve
//             you.
//           </Text>
//           <View style={{ marginTop: 15 }}>
//             <Text>
//               First Party:{" "}
//               <Text style={{ color: "red" }}>
//                 {quotationDetails?.quotation?.company?.name}
//               </Text>
//             </Text>
//             <Text>
//               Second Party:{" "}
//               <Text style={{ color: "red" }}>{quotationDetails?.client}</Text>
//             </Text>
//           </View>
//           <Text
//             style={{
//               marginTop: 15,
//               textDecoration: "underline",
//               fontFamily: "Helvetica-Bold",
//             }}
//           >
//             Table 1: Monthly Service charges
//           </Text>
//           <Text
//             style={{
//               marginTop: 15,
//               textDecoration: "underline",
//               fontFamily: "Helvetica-Bold",
//             }}
//           >
//             PROPOSAL - MONTHLY COST
//           </Text>

//           {/* table */}

//           <View
//             style={{
//               width: "100%",
//               // border: 1,
//               marginTop: 10,
//               borderBottom: 1,
//             }}
//           >
//             {/* titles */}
//             <View
//               style={{
//                 flexDirection: "row",
//                 width: "100%",
//                 borderTop: 0.5,
//                 borderBottom: 0.5,
//                 borderLeft: 1,
//               }}
//             >
//               <View
//                 style={{
//                   // height: 40,
//                   backgroundColor: "#ddd",
//                   padding: 3,
//                   paddingVertical: 6,
//                   width: `${100 / generatedTitles.length}%`,
//                   borderRight: 1,
//                   fontSize: 8,
//                   fontFamily: "Helvetica-Bold",
//                   alignItems: "center",
//                 }}
//               >
//                 <Text style={{ textAlign: "center" }}>Sl NO.</Text>
//               </View>
//               {generatedTitles?.map((item, index) => (
//                 <View
//                   style={{
//                     // height: 40,
//                     backgroundColor: "#ddd",
//                     padding: 3,
//                     paddingVertical: 6,
//                     width: `${100 / generatedTitles.length}%`,
//                     borderRight: 1,
//                     fontSize: 8,
//                     fontFamily: "Helvetica-Bold",
//                     alignItems: "center",
//                   }}
//                   key={index}
//                 >
//                   <Text style={{ textAlign: "center" }}>{item?.col}</Text>
//                 </View>
//               ))}
//             </View>
//             {/* rows */}
//             {TableRowLists?.map((item, index) => (
//               <View
//                 key={index}
//                 style={{
//                   flexDirection: "row",
//                   borderTop: 0.5,
//                   borderBottom: 0.5,
//                   borderLeft: 1,
//                 }}
//               >
//                 <View
//                   style={{
//                     padding: 3,
//                     width: `${100 / generatedTitles.length}%`,
//                     borderRight: 1,
//                     fontSize: 8,
//                   }}
//                 >
//                   <Text style={{ textAlign: "center" }} break>
//                     {index + 1}
//                   </Text>
//                 </View>
//                 {generatedTitles?.map((head, headIndx) => (
//                   <View
//                     key={headIndx}
//                     style={{
//                       paddingHorizontal: 3,
//                       paddingVertical: 2,
//                       width: `${100 / generatedTitles.length}%`,
//                       borderRight: 1,
//                       fontSize: 8,
//                       justifyContent: "center",
//                       alignItems: "center",
//                     }}
//                   >
//                     <Text
//                       style={{
//                         textAlign: "center",
//                         width: "100%",
//                       }}
//                       break
//                     >
//                       {splitWord(item[head?.title], 8)}
//                     </Text>
//                   </View>
//                 ))}
//               </View>
//             ))}
//           </View>
//           {/* note */}

//           {notes?.length > 0 && (
//             <Text
//               style={{
//                 fontSize: 12,
//                 fontFamily: "Helvetica-Bold",
//                 marginVertical: 20,
//               }}
//             >
//               Note:-
//             </Text>
//           )}
//           {notes?.length > 0 &&
//             notes?.map((item, index) => (
//               <Text key={index} style={{ marginBottom: 10 }}>
//                 {index + 1}. <Text>{item?.description}</Text>
//               </Text>
//             ))}

//           {/* <View fixed>

//         <Image source={require("./assets/footer.jpg")}  />
//         </View>
//       </Page> */}
//           {/* page 2 */}
//           {/* <Page size="A4" style={styles.page}>
//         <Image source={require("./assets/header.jpg")} /> */}
//           {terms?.length > 0 && (
//             <Text
//               style={{
//                 marginTop: 15,
//                 textDecoration: "underline",
//                 fontFamily: "Helvetica-Bold",
//               }}
//             >
//               Table 2: TERMS & CONDITIONS:
//             </Text>
//           )}
//           {/* table */}
//           {terms?.length > 0 && (
//             <View style={{ marginTop: 15, fontSize: 10 }}>
//               <View style={{ padding: 6 }}></View>
//               <View
//                 style={{
//                   flexDirection: "row",
//                   borderBottom: 0.5,
//                   borderTop: 0.5,
//                   borderLeft: 1,
//                   backgroundColor: "black",
//                 }}
//               >
//                 {/* col 1 */}
//                 <View
//                   style={{
//                     borderRight: 1,
//                     padding: 3,
//                     width: "100px",
//                     justifyContent: "center",
//                     alignItems: "center",
//                   }}
//                 >
//                   <Text style={{ textAlign: "center", color: "white" }} break>
//                     SL.NO
//                   </Text>
//                 </View>
//                 {/* col 2 */}
//                 <View style={{ borderRight: 1, padding: 3, width: "300px" }}>
//                   <Text break style={{ color: "white", textAlign: "center" }}>
//                     PARTICULARS
//                   </Text>
//                 </View>
//                 {/* col 3 */}
//                 <View style={{ borderRight: 1, padding: 3, width: "100%" }}>
//                   <Text break style={{ color: "white", textAlign: "center" }}>
//                     REMARK
//                   </Text>
//                 </View>
//               </View>
//               <View style={{ borderBottom: 1 }}>
//                 {/* row 1 */}
//                 {terms?.map((item, termsIndex) => (
//                   <View
//                     key={termsIndex}
//                     style={{
//                       flexDirection: "row",
//                       borderBottom: 0.5,
//                       borderTop: 0.5,
//                       borderLeft: 1,
//                     }}
//                   >
//                     {/* col 1 */}
//                     <View
//                       style={{
//                         borderRight: 1,
//                         padding: 3,
//                         width: "100px",
//                         justifyContent: "center",
//                         alignItems: "center",
//                       }}
//                     >
//                       <Text style={{ textAlign: "center" }} break>
//                         {termsIndex + 1}
//                       </Text>
//                     </View>
//                     {/* col 2 */}
//                     <View
//                       style={{ borderRight: 1, padding: 3, width: "300px" }}
//                     >
//                       <Text break>{item.particulars}</Text>
//                     </View>
//                     {/* col 3 */}
//                     <View style={{ borderRight: 1, padding: 3, width: "100%" }}>
//                       <Text break>{item.remark}</Text>
//                     </View>
//                   </View>
//                 ))}
//               </View>
//             </View>
//           )}

//           <View style={{ fontSize: 11, marginTop: 15, lineHeight: 2 }}>
//             <Text>
//               We trust that the proposed Quotation will be meeting your
//               expectations.{" "}
//             </Text>
//             <Text>
//               Thanking you & assuring you of our best services at all times.
//             </Text>
//             <Text>Yours Sincerely,</Text>
//             <Text style={{ fontFamily: "Helvetica-Bold", marginVertical: 5 }}>
//               With Regards,
//             </Text>
//             <Text style={{ fontFamily: "Helvetica-Bold" }}>Vinod D’cunha</Text>
//             <Text style={{ fontFamily: "Helvetica-Bold", marginBottom: 60 }}>
//               Operations Manager
//             </Text>
//           </View>
//         </View>
//         <Image
//           src={
//             company?.footer && company?.footer != ""
//               ? returnSrc(company?.footer)
//               : footerImg
//           }
//           fixed
//           style={{
//             position: "absolute",
//             bottom: 0,
//             left: 0,
//             right: 0,
//           }}
//         />
//       </Page>
//     </Document>
//   );
// }

import { Document, Text, View } from "@react-pdf/renderer";
import PageLayout from "../../../Contract/contractPdf/contractService/PageLayout";
import { splitWord } from "../../../../../../utils/functions";
export default function MonthlyQuotation({
  generatedTitles,
  quotationDetails,
  TableRowLists,
  terms,
  notes,
}) {
  console.log(
    "generate titles check......New....",
    generatedTitles,
    quotationDetails,
    TableRowLists
  );
  const currentDate = new Date();

  const day = currentDate.getDate();
  const month = currentDate.getMonth() + 1; // Month is zero-based, so we add 1
  const year = currentDate.getFullYear();

  const formattedDate = `${day}/${month}/${year}`;
  return (
    <>
      <Document>
        <PageLayout pageNo={1}>
          <View>
            <Text
              style={{
                textAlign: "center",
                textDecoration: "underline",
                marginTop: 10,
                fontSize: 12,
                fontFamily: "Helvetica-Bold",
              }}
            >
              QUOTATION
            </Text>
            <View
              style={{
                flexDirection: "row",
                alignItems: "center",
                justifyContent: "space-between",
                marginTop: 10,
                fontSize: 12,
              }}
            >
              <Text>
                Ref no:{" "}
                <Text>{quotationDetails?.quotation?.reference_number}</Text>
              </Text>
              <Text>
                Date: <Text>{formattedDate}</Text>
              </Text>
            </View>
            <View style={{ fontSize: 11, marginTop: 10 }}>
              <Text style={{ marginBottom: 1 }}>To,</Text>
              <Text style={{ marginBottom: 1 }}>
                {quotationDetails?.quotation?.client?.authorized_person_name}
              </Text>
              <Text style={{ marginBottom: 1 }}>
                {quotationDetails?.client}
              </Text>
              <Text style={{ fontFamily: "Helvetica-Bold" }}>K.S.A.</Text>
            </View>
            <Text style={{ marginTop: 15 }}>Dear Sir,</Text>
            <Text style={{ marginTop: 15 }}>
              Thank you for having trusted us and giving an opportunity to serve
              you.
            </Text>
            <View style={{ marginTop: 15 }}>
              <Text>
                First Party:{" "}
                <Text>{quotationDetails?.quotation?.company?.name}</Text>
              </Text>
              <Text>
                Second Party: <Text>{quotationDetails?.client}</Text>
              </Text>
            </View>
            <Text
              style={{
                marginTop: 15,
                textDecoration: "underline",
                fontFamily: "Helvetica-Bold",
              }}
            >
              Table 1: {quotationDetails?.quotation_type} Service charges
            </Text>
            <Text
              style={{
                marginTop: 15,
                textDecoration: "underline",
                fontFamily: "Helvetica-Bold",
              }}
            >
              PROPOSAL - {quotationDetails?.quotation_type} COST
            </Text>

            {/* table */}

            <View
              style={{
                width: "100%",
                // border: 1,
                marginTop: 10,
                borderBottom: 1,
              }}
            >
              {/* titles */}
              <View
                style={{
                  flexDirection: "row",
                  width: "100%",
                  borderTop: 0.5,
                  borderBottom: 0.5,
                  borderLeft: 1,
                }}
              >
                <View
                  style={{
                    // height: 40,
                    backgroundColor: "#ddd",
                    padding: 3,
                    paddingVertical: 6,
                    width: `${100 / generatedTitles.length}%`,
                    borderRight: 1,
                    fontSize: 8,
                    fontFamily: "Helvetica-Bold",
                    alignItems: "center",
                  }}
                >
                  <Text style={{ textAlign: "center" }}>Sl NO.</Text>
                </View>
                {generatedTitles?.map((item, index) => (
                  <View
                    style={{
                      // height: 40,
                      backgroundColor: "#ddd",
                      padding: 3,
                      paddingVertical: 6,
                      width: `${100 / generatedTitles.length}%`,
                      borderRight: 1,
                      fontSize: 8,
                      fontFamily: "Helvetica-Bold",
                      alignItems: "center",
                    }}
                    key={index}
                  >
                    <Text style={{ textAlign: "center" }}>{item?.col}</Text>
                  </View>
                ))}
              </View>
              {/* rows */}
              {TableRowLists?.map((item, index) => (
                <View
                  key={index}
                  style={{
                    flexDirection: "row",
                    borderTop: 0.5,
                    borderBottom: 0.5,
                    borderLeft: 1,
                  }}
                >
                  <View
                    style={{
                      padding: 3,
                      width: `${100 / generatedTitles.length}%`,
                      borderRight: 1,
                      fontSize: 8,
                    }}
                  >
                    <Text style={{ textAlign: "center" }} break>
                      {index + 1}
                    </Text>
                  </View>
                  {generatedTitles?.map((head, headIndx) => (
                    <View
                      key={headIndx}
                      style={{
                        paddingHorizontal: 3,
                        paddingVertical: 2,
                        width: `${100 / generatedTitles.length}%`,
                        borderRight: 1,
                        fontSize: 8,
                        justifyContent: "center",
                        alignItems: "center",
                      }}
                    >
                      <Text
                        style={{
                          textAlign: "center",
                          width: "100%",
                        }}
                        break
                      >
                        {splitWord(item[head?.title], 8)}
                      </Text>
                    </View>
                  ))}
                </View>
              ))}
            </View>
            {/* note */}

            {notes?.length > 0 && (
              <Text
                style={{
                  fontSize: 12,
                  fontFamily: "Helvetica-Bold",
                  marginVertical: 20,
                }}
              >
                Note:-
              </Text>
            )}
            {notes?.length > 0 &&
              notes?.map((item, index) => (
                <Text key={index} style={{ marginBottom: 10 }}>
                  {index + 1}. <Text>{item?.description}</Text>
                </Text>
              ))}

            {/* <View fixed>

        <Image source={require("./assets/footer.jpg")}  />
        </View>
      </Page> */}
            {/* page 2 */}
            {/* <Page size="A4" style={styles.page}>
        <Image source={require("./assets/header.jpg")} /> */}
            {terms?.length > 0 && (
              <Text
                style={{
                  marginTop: 15,
                  textDecoration: "underline",
                  fontFamily: "Helvetica-Bold",
                }}
              >
                Table 2: TERMS & CONDITIONS:
              </Text>
            )}
            {/* table */}
            {terms?.length > 0 && (
              <View style={{ marginTop: 15, fontSize: 10 }}>
                <View style={{ padding: 6 }}></View>
                <View
                  style={{
                    flexDirection: "row",
                    borderBottom: 0.5,
                    borderTop: 0.5,
                    borderLeft: 1,
                    backgroundColor: "black",
                  }}
                >
                  {/* col 1 */}
                  <View
                    style={{
                      borderRight: 1,
                      padding: 3,
                      width: "100px",
                      justifyContent: "center",
                      alignItems: "center",
                    }}
                  >
                    <Text style={{ textAlign: "center", color: "white" }} break>
                      SL.NO
                    </Text>
                  </View>
                  {/* col 2 */}
                  <View style={{ borderRight: 1, padding: 3, width: "300px" }}>
                    <Text break style={{ color: "white", textAlign: "center" }}>
                      PARTICULARS
                    </Text>
                  </View>
                  {/* col 3 */}
                  <View style={{ borderRight: 1, padding: 3, width: "100%" }}>
                    <Text break style={{ color: "white", textAlign: "center" }}>
                      REMARK
                    </Text>
                  </View>
                </View>
                <View style={{ borderBottom: 1 }}>
                  {/* row 1 */}
                  {terms?.map((item, termsIndex) => (
                    <View
                      key={termsIndex}
                      style={{
                        flexDirection: "row",
                        borderBottom: 0.5,
                        borderTop: 0.5,
                        borderLeft: 1,
                      }}
                    >
                      {/* col 1 */}
                      <View
                        style={{
                          borderRight: 1,
                          padding: 3,
                          width: "100px",
                          justifyContent: "center",
                          alignItems: "center",
                        }}
                      >
                        <Text style={{ textAlign: "center" }} break>
                          {termsIndex + 1}
                        </Text>
                      </View>
                      {/* col 2 */}
                      <View
                        style={{ borderRight: 1, padding: 3, width: "300px" }}
                      >
                        <Text break>{item.particulars}</Text>
                      </View>
                      {/* col 3 */}
                      <View
                        style={{ borderRight: 1, padding: 3, width: "100%" }}
                      >
                        <Text break>{item.remark}</Text>
                      </View>
                    </View>
                  ))}
                </View>
              </View>
            )}

            <View style={{ fontSize: 11, marginTop: 15, lineHeight: 2 }}>
              <Text>
                We trust that the proposed Quotation will be meeting your
                expectations.{" "}
              </Text>
              <Text>
                Thanking you & assuring you of our best services at all times.
              </Text>
              <Text>Yours Sincerely,</Text>
              <Text style={{ fontFamily: "Helvetica-Bold", marginVertical: 5 }}>
                With Regards,
              </Text>
              <Text style={{ fontFamily: "Helvetica-Bold" }}>
                Vinod D’cunha
              </Text>
              <Text style={{ fontFamily: "Helvetica-Bold", marginBottom: 60 }}>
                Chief Operations Manager
              </Text>
            </View>
          </View>
        </PageLayout>
      </Document>
    </>
  );
}
